export const CARRIER_NAMES = {
  hermes: "Evri",
  collectplus: "Collectplus",
  dhl: "DHL",
};